import React from 'react';
import { TranslatedComponent, NumberDisplay } from 'components/';
import { withTranslation } from 'react-i18next';
import { AvailabilityRowStyled } from './AvailabilityRow.styled';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import InfoIcon from '@material-ui/icons/Info';
import { PropTypes } from 'prop-types';
import {
  Button,
  CircularProgress,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from '@material-ui/icons/Delete';
import { createTestBooking } from '../../services/api';
import { toast } from 'react-toastify';
class AvailabilityRow extends TranslatedComponent {
  static propTypes = {
    row: PropTypes.object,
    type: PropTypes.string,
    priceItemsOpenModal: PropTypes.func,
    jsonViewOpenModal: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      additionalsModalOpen: false,
      selectedAdditionals: [],
    };
  }

  handleOpenAdditionalsModal = () => {
    this.setState({ additionalsModalOpen: true });
  };

  handleCloseAdditionalsModal = () => {
    this.setState({ additionalsModalOpen: false });
  };

  handleAddAdditional = (additional) => {
    const { selectedAdditionals } = this.state;
    const exists = selectedAdditionals.find(item => item.id === additional.id);

    if (!exists) {
      this.setState({
        selectedAdditionals: [...selectedAdditionals, { ...additional, quantity: 1 }],
      });
    }
  };

  handleRemoveAdditional = (additionalId) => {
    const { selectedAdditionals } = this.state;
    this.setState({
      selectedAdditionals: selectedAdditionals.filter(item => item.id !== additionalId),
    });
  };

  handleChangeQuantity = (additionalId, newQuantity) => {
    const { selectedAdditionals } = this.state;
    const quantity = Math.max(1, parseInt(newQuantity) || 1);

    this.setState({
      selectedAdditionals: selectedAdditionals.map(item =>
        item.id === additionalId ? { ...item, quantity } : item
      ),
    });
  };

  async createTestBooking() {
    const { brokerId, commercialAgreement, row } = this.props;
    const { selectedAdditionals } = this.state;

    this.setState({ loading: true });
    try {
      await createTestBooking(row, brokerId, commercialAgreement, selectedAdditionals);
      toast.success('Reserva creada con exito!');
      this.setState({ selectedAdditionals: [], additionalsModalOpen: false });
    } catch (error) {
      toast.error(
        `No se pudo crear la reserva: [${error.response.data.errorCode}] ${error.response.data.errorMessage}`,
      );
      // eslint-disable-next-line no-console
      console.log(error.response.data);
    }
    this.setState({ loading: false });
  }

  render() {
    const { t, row, type, priceItemsOpenModal, jsonViewOpenModal } = this.props;
    const { loading, additionalsModalOpen, selectedAdditionals } = this.state;

    if (!row) return;

    const additionalsPriceList = row.additionalsPrices || row.additionalsPrice || [];

    const info = {
      model:
        type === 'iata'
          ? row.model
          : {
            ...row.car.model,
            ...{
              franchise: row.franchise,
              franchiseDamage: row.franchiseDamage,
              franchiseRollover: row.franchiseRollover,
              franchiseTheft: row.franchiseTheft,
            },
          },
      brand: type === 'iata' ? row.model.brand : row.car.model.brand.name,
      category: row.category.name,
    };

    return (
      <AvailabilityRowStyled className="row mr-0 ml-0 d-flex search-item-row car-item pt-4 pb-4 pl-4 pr-4">
        <div className="col-lg-9 col-md-12 car-description">
          <div className="car-image mr-4" style={{ position: 'relative' }}>
            <img
              className="img-fluid"
              src={info.model.imagePath}
              alt={info.model.name}
            />
            {additionalsPriceList.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                marginTop: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1,
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                maxWidth: '450px',
                gap: '2px'
              }}>
                {additionalsPriceList.map((additional, index) => (
                  <Tooltip key={index} title={additional.description} arrow>
                    <img
                      src={additional.imagePath}
                      alt={additional.description}
                      style={{
                        width: '36px',
                        height: '36px',
                        cursor: 'pointer'
                      }}
                    />
                  </Tooltip>
                ))}
              </div>
            )}
          </div>
          <div className="car-info">
            <h2 className="car-name">
              {info.brand} {info.model.name}
              <Tooltip title="Más info" arrow>
                <InfoIcon
                  className="info-icon"
                  style={{
                    marginLeft: '8px',
                    cursor: 'pointer',
                    color: '#1976d2',
                    fontSize: '20px'
                  }}
                  onClick={() => jsonViewOpenModal(row)}
                />
              </Tooltip>
            </h2>
            <p>
              <b>{t('category')}:</b> {row.category.name}
              <span className="mr-2 ml-2 separator md-hidden">|</span>
              <span className="tachometer md-hidden">
                <i className="fas fa-tachometer-alt mr-1"></i>
                <b>{t('KmIlimitados')}:</b>{' '}
                {row.ilimitedKm === true ? 'Si' : 'No'}
              </span>
            </p>
            <div className="car-details md-hidden">
              <p className="franchise mt-0">
                <i
                  className="fas fa-info-circle"
                  data-toggle="tooltip"
                  title={t('franchiseHelpText')}
                />
                <strong> {t('franquicia')} </strong>
                <NumberDisplay value={info.model.franchise} />
              </p>
              <p className="franchise mt-0">
                <strong> Franquicia Vuelco </strong>
                <NumberDisplay value={info.model.franchiseRollover} />
              </p>
              <p className="franchise mt-0">
                <strong> Franquicia Robo </strong>
                <NumberDisplay value={info.model.franchiseTheft} />
              </p>
              <p className="franchise mt-0">
                <strong> Franquicia Daño </strong>
                <NumberDisplay value={info.model.franchiseDamage} />
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-12 car-price">
          {row.supplier && row.supplier.logoPath ? (
            <img
              src={row.supplier.logoPath}
              alt={row.supplier.name}
              width={70}
              height={30}
            />
          ) : (
            ''
          )}
          <p className="rent-days mb-0 mt-2">
            {t('alquilerPor')}
            <span>
              {' '}
              <strong>{row.totalDaysString}</strong>{' '}
            </span>
          </p>
          <p className="rent-price mt-0 mb-0">
            <NumberDisplay
              value={row.price}
              showPrefix
              currency={row.currency}
            />
            <HelpOutlineIcon
              className="help-icon"
              style={{ margin: '0px 0px 8px 4px', cursor: 'pointer' }}
              onClick={() => priceItemsOpenModal(row)}
            />
          </p>
          <Button
            variant="text"
            size="small"
            style={{ fontSize: '12px', textTransform: 'none', padding: '4px 8px', marginLeft: '10px' }}
            onClick={this.handleOpenAdditionalsModal}
          >
            + adicionales {selectedAdditionals.length > 0 && `(${selectedAdditionals.length})`}
          </Button>
          <br />
          <Button
            variant="outlined"
            style={{ height: '55px', marginLeft: '10px' }}
            color="primary"
            onClick={() => this.createTestBooking()}
            disabled={loading}
          >
            {loading && <CircularProgress size={14} />}&nbsp;Reserva Test
          </Button>
        </div>
        <Dialog
          open={additionalsModalOpen}
          onClose={this.handleCloseAdditionalsModal}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Seleccionar Adicionales
          </DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: '20px' }}>
              <h4>Adicionales Disponibles:</h4>
              {row.additionalsPrice && row.additionalsPrice.length > 0 ? (
                <List>
                  {row.additionalsPrice.map((additional) => {
                    const isSelected = selectedAdditionals.find(item => item.id === additional.id);
                    return (
                      <ListItem
                        key={additional.id}
                        style={{
                          border: '1px solid #ddd',
                          marginBottom: '8px',
                          borderRadius: '4px',
                          backgroundColor: isSelected ? '#e3f2fd' : 'transparent'
                        }}
                      >
                        <img
                          src={additional.imagePath}
                          alt={additional.description}
                          style={{ width: '40px', height: '40px', marginRight: '16px' }}
                        />
                        <ListItemText
                          primary={additional.description}
                          secondary={`Precio: $${additional.price || 0}`}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          style={{ minWidth: '90px' }}
                          onClick={() => this.handleAddAdditional(additional)}
                          disabled={isSelected}
                        >
                          {isSelected ? 'Agregado' : 'Agregar'}
                        </Button>
                      </ListItem>
                    );
                  })}
                </List>
              ) : (
                <p>No hay adicionales disponibles para este auto</p>
              )}
            </div>
            {selectedAdditionals.length > 0 && (
              <div>
                <h4>Adicionales Seleccionados:</h4>
                <List>
                  {selectedAdditionals.map((item) => (
                    <ListItem
                      key={item.id}
                      style={{
                        border: '1px solid #4caf50',
                        marginBottom: '8px',
                        borderRadius: '4px',
                        backgroundColor: '#f1f8f4'
                      }}
                    >
                      <img
                        src={item.imagePath}
                        alt={item.description}
                        style={{ width: '40px', height: '40px', marginRight: '16px' }}
                      />
                      <ListItemText
                        primary={item.description}
                        secondary={`Precio: $${item.price || 0}`}
                      />
                      <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                        <IconButton
                          size="small"
                          onClick={() => this.handleChangeQuantity(item.id, item.quantity - 1)}
                          disabled={item.quantity <= 1}
                        >
                          <RemoveIcon />
                        </IconButton>
                        <TextField
                          type="number"
                          value={item.quantity}
                          onChange={(e) => this.handleChangeQuantity(item.id, e.target.value)}
                          inputProps={{ min: 1, style: { textAlign: 'center', width: '50px' } }}
                          variant="outlined"
                          size="small"
                        />
                        <IconButton
                          size="small"
                          onClick={() => this.handleChangeQuantity(item.id, item.quantity + 1)}
                        >
                          <AddIcon />
                        </IconButton>
                      </div>
                      <IconButton
                        onClick={() => this.handleRemoveAdditional(item.id)}
                        color="secondary"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseAdditionalsModal} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </AvailabilityRowStyled>
    );
  }
}

export default withTranslation()(AvailabilityRow);
